<template>
  <div>
    <b-modal
      id="modalSelectArticle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <div class="row" v-if="currentItem">
          <div class="col-md-12">
            <p class="text-center font-weight-bold font-size-17">
              <b>{{
                currentItem.libelle
                  ? 'Etape ' + (currentIndex + 1) + ' : ' + currentItem.libelle
                  : 'Etape ' + (currentIndex + 1)
              }}</b>
            </p>
            <hr />
          </div>
        </div>
        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche article"
                      disable-filtering-by-search
                      @search="onSearchArticle"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          noData
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Unité : {{ item.unite }}
                            </span>
                            <span v-if="item.article_type" class="d-block">
                              Type d'article :
                              {{
                                item.article_type === 'produits'
                                  ? 'Produit'
                                  : 'Service'
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-8">Article</th>
                  <th class="col-3 text-center">Quantité</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in itemLists"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-8" style="vertical-align: middle">
                    Désignation : {{ item.designation }} <br />
                    Référence : {{ item.reference }} <br />
                    Stock :
                    {{
                      item.stock !== '-'
                        ? item.stock + ' ' + item.unite
                        : item.stock
                    }}
                  </td>
                  <td class="col-3 text-center" style="vertical-align: middle">
                    <div class="input-group">
                      <input
                        class="form-control"
                        v-model="item.quantite"
                        type="text"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                      />
                      <div class="input-group-append bg-transparent">
                        <span class="input-group-text bg-transprent">
                          {{ item.unite }}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i
                        :class="modal.ICON_TRASH"
                        class="font-size-17 text-danger"
                      ></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="itemLists.length === 0" class="d-flex">
                  <td class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalSelectArticle')"
        >
          Fermer
        </button>
        <button type="button" class="btn btn-success" @click="submit">
          Ajouter
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL_ARTICLE from '@/http/article_stock/article';
import { CoolSelect } from 'vue-cool-select';
import { modal } from '@/icons/gpao/nomenclature';
export default {
  data() {
    return {
      modal,

      articles: [],
      itemLists: [],
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,
    };
  },
  components: {
    CoolSelect,
  },
  methods: {
    onSelectedArticle: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.itemLists,
          (o) => o.uuid === select.uuid
        );
        if (!objExiste) {
          this.itemLists.push({
            uuid: select.uuid,
            designation: select.designation,
            reference: select.reference,
            unite: select.unite,
            quantite: 1,
            stock: select.stock,
            type: this.currentType,
          });
        } else {
          objExiste.quantite += 1;
        }

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        let params = {
          search: search,
          onlyProduit: false,
          sortBy: 'designation',
          sortDesc: false,
        };
        if (this.currentType === 'production') {
          params = {
            search: search,
            onlyProduit: true,
            sortBy: 'designation',
            sortDesc: false,
          };
        }
        await window.axios
          .get(URL_ARTICLE.SEARCH_ARTICLE, {
            params: params,
          })
          .then((resp) => {
            //this.articles = resp.data;
            this.articles = resp.data.filter(
              (article) => article.uuid !== this.selectedProduit.uuid
            );
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    removeItem(index) {
      this.itemLists.splice(index, 1);
    },
    submit() {
      this.$emit('onArticleEtapeSelected', this.itemLists);
      this.$bvModal.hide('modalSelectArticle');
    },
    showModal() {
      this.itemLists = this.currentArticles;
      this.$bvModal.show('modalSelectArticle');
    },
  },
  props: [
    'currentItem',
    'currentArticles',
    'selectedProduit',
    'currentType',
    'currentIndex',
    'titleModal',
  ],
};
</script>

<style scoped lang="scss"></style>
